import {
  hourOptions,
  minuteOptions,
  splitHoursMinutes,
  fromHoursMinutes,
} from '../utils/recipeTime';

// Hours + minutes dropdown pair for prep/cook time. Replaces a free-text field so there is
// nothing to parse on save: the value is always canonical minutes, or null when both
// dropdowns are blank. The blank option is the unit word ("hrs"/"mins"), which reads as a
// placeholder visually and gives screen readers something better than a bare dash.
export function TimeSelect({ label, idPrefix, minutes, onChange }) {
  const { hours, mins } = splitHoursMinutes(minutes);

  const selectClass =
    'w-full px-3 py-3 bg-input rounded-xl border border-[var(--border)] focus:border-primary focus:ring-2 focus:ring-primary outline-none text-foreground';
  const nativeSelect = { WebkitAppearance: 'menulist', appearance: 'auto' };
  const toValue = (raw) => (raw === '' ? null : Number(raw));

  return (
    <div>
      <span id={`${idPrefix}-label`} className="block text-foreground mb-2 text-sm">
        {label}
      </span>
      <div className="flex gap-2" role="group" aria-labelledby={`${idPrefix}-label`}>
        <select
          id={`${idPrefix}-hours`}
          aria-label={`${label} — hours`}
          value={hours ?? ''}
          onChange={(e) => onChange(fromHoursMinutes(toValue(e.target.value), mins))}
          className={selectClass}
          style={nativeSelect}
        >
          <option value="">hrs</option>
          {hourOptions(hours).map((h) => (
            <option key={h} value={h}>
              {h} {h === 1 ? 'hr' : 'hrs'}
            </option>
          ))}
        </select>
        <select
          id={`${idPrefix}-minutes`}
          aria-label={`${label} — minutes`}
          value={mins ?? ''}
          onChange={(e) => onChange(fromHoursMinutes(hours, toValue(e.target.value)))}
          className={selectClass}
          style={nativeSelect}
        >
          <option value="">mins</option>
          {minuteOptions(mins).map((m) => (
            <option key={m} value={m}>
              {m} {m === 1 ? 'min' : 'mins'}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
